import {useEffect} from "react";

const Loading = () => {

  useEffect(() => {
    if (localStorage.getItem('userInfo')) {
      if (localStorage.getItem('expiration')) {
        if (localStorage.getItem('token')) {
          window.location.href = '/';
          if (localStorage.getItem('defaultItem')) {
            localStorage.setItem('lastClicked', localStorage.getItem('defaultItem'));
            localStorage.removeItem('defaultItem');
          }
        }
      }
    }
  }, []);
}

export default Loading;
